import { type HTMLAttributes, type ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './MetricLabel.module.css';

export interface MetricLabelProps extends HTMLAttributes<HTMLDivElement> {
  label: string;
  value: ReactNode;
  unit?: string;
  trend?: string;
  /** Required glossary term id for explainability wiring */
  glossaryTermId: string;
  status?: 'fresh' | 'stale' | 'partial' | 'unavailable';
  onExplain?: () => void;
}

export function MetricLabel({
  label,
  value,
  unit,
  trend,
  glossaryTermId,
  status = 'fresh',
  onExplain,
  className,
  ...props
}: MetricLabelProps) {
  return (
    <div
      className={clsx(styles.root, className)}
      data-status={status}
      data-glossary-term-id={glossaryTermId}
      {...props}
    >
      <div className={styles.labelRow}>
        <span>{label}</span>
        {onExplain && (
          <button
            type="button"
            className={styles.explainBtn}
            onClick={onExplain}
            aria-label={`Explain ${label}`}
          >
            ?
          </button>
        )}
      </div>
      <div className={styles.value}>
        {value}
        {unit && <small className={styles.unit}>{unit}</small>}
      </div>
      {trend && <span className={styles.trend}>{trend}</span>}
    </div>
  );
}
